import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useClusterStore } from '../../stores/clusterStore';
import { usePaletteStore } from '../../stores/paletteStore';
import type { BulkSection } from '../../stores/bulkStore';
import { InspectorHeader } from './InspectorHeader';
import { InspectorRail } from './InspectorRail';
import { BulkActionBar } from './BulkActionBar';
import { CommandPalette } from './CommandPalette';

function sectionFromPath(pathname: string): BulkSection | null {
  const seg = pathname.split('/').filter(Boolean)[0];
  if (seg === 'queues') return 'queues';
  if (seg === 'services') return 'services';
  if (seg === 'nodes') return 'nodes';
  return null;
}

export function AppShell() {
  const location = useLocation();
  const activeSlug = useClusterStore(s => s.activeSlug);
  const section = sectionFromPath(location.pathname);
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    setNavOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    const onKey = (e: KeyboardEvent): void => {
      if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault();
        usePaletteStore.getState().toggle();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-bg font-sans text-text">
      <InspectorRail open={navOpen} />
      {navOpen && (
        <div
          aria-hidden
          onClick={() => setNavOpen(false)}
          className="fixed inset-0 z-40 bg-black/40 md:hidden"
        />
      )}
      <div className="relative flex min-w-0 flex-1 flex-col">
        <InspectorHeader onMenuClick={() => setNavOpen(true)} />
        <Outlet />
        {section && (
          <BulkActionBar
            section={section}
            cluster={activeSlug === 'all' ? '' : activeSlug}
          />
        )}
      </div>
      <CommandPalette />
    </div>
  );
}
